module.exports = __webpack_public_path__ + "assets/img/btn-back-ec99e431.png";